import React from "react";

function Calendar() {
  return (
    <>
      <h2 className="mt-32 text-6xl text-center">Meet our Calendar.</h2>
    </>
  );
}

export default Calendar;
